import { render, staticRenderFns } from "./CatalogoArtistas.vue?vue&type=template&id=ed3da386&scoped=true"
import script from "./CatalogoArtistas.vue?vue&type=script&lang=js"
export * from "./CatalogoArtistas.vue?vue&type=script&lang=js"
import style0 from "./CatalogoArtistas.vue?vue&type=style&index=0&id=ed3da386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3da386",
  null
  
)

export default component.exports